// Shared HSN directory loader and search, used by the tax profile suggestions (HsnSuggestInput)
// and the public HSN code finder page.

const MIN_CHARS = 1;

// The directory file is downloaded once, when a user first focuses a search field,
// and kept for the session. Each row is [code, description, gstRate or null].
// no-cache = the browser re-checks the file, so a yearly update reaches users.
let directoryPromise = null;

export function loadDirectory() {
  if (!directoryPromise) {
    directoryPromise = fetch('/data/hsn-directory.json', { cache: 'no-cache' })
      .then(res => res.json())
      .then(data => data.items || [])
      .catch(() => {
        directoryPromise = null;
        return [];
      });
  }
  return directoryPromise;
}

function searchByCode(directory, text, maxResults) {
  const result = [];
  for (let i = 0; i < directory.length; i++) {
    if (directory[i][0].startsWith(text)) {
      result.push(directory[i]);
      if (result.length === maxResults) {
        break;
      }
    }
  }
  return result;
}

// Every typed word must be in the description. Descriptions that start with what the user
// typed come first, so "mobile" lists "Mobile phones..." before "...for mobile...".
function searchByName(directory, text, maxResults) {
  const typed = text.toLowerCase().trim();
  const words = typed.split(' ').filter(w => w);
  const startsWithTyped = [];
  const otherMatches = [];
  for (let i = 0; i < directory.length; i++) {
    const description = directory[i][1].toLowerCase();
    const allWordsFound = words.every(w => description.includes(w));
    if (!allWordsFound) {
      continue;
    }
    if (description.startsWith(typed)) {
      startsWithTyped.push(directory[i]);
      if (startsWithTyped.length === maxResults) {
        break;
      }
    } else if (otherMatches.length < maxResults) {
      otherMatches.push(directory[i]);
    }
  }
  return startsWithTyped.concat(otherMatches).slice(0, maxResults);
}

export function findHsnSuggestions(directory, text, maxResults) {
  const trimmed = text.trim();
  if (trimmed.length < MIN_CHARS) {
    return [];
  }
  const startsWithDigit = /^\d/.test(trimmed);
  if (startsWithDigit) {
    return searchByCode(directory, trimmed, maxResults);
  }
  return searchByName(directory, trimmed, maxResults);
}
